if (!customElements.get('ss-gift-card-form')) {
  customElements.define('ss-gift-card-form', class extends HTMLElement {
    connectedCallback() {
      this.uid = this.dataset.uid;
      this.maxChars = Number(this.dataset.maxChars) || 200;
      this.mode = 'email';

      this.inputs = Array.from(this.querySelectorAll('[data-ss-gc-input]'));
      this.emailInput = this.querySelector('[data-ss-gc-email]');
      this.dateInput = this.querySelector('input[type="date"]');
      this.messageInput = this.querySelector('[data-ss-gc-message]');
      this.counter = this.querySelector('[data-ss-gc-counter]');
      this.sendFlag = this.querySelector('[data-ss-gc-send-flag]');
      this.offsetInput = this.querySelector('[data-ss-gc-offset]');
      this.modal = this.querySelector('[data-ss-gc-modal]');

      if (this.offsetInput) {
        this.offsetInput.value = new Date().getTimezoneOffset().toString();
      }

      this.onClick = this.onClick.bind(this);
      this.onInput = this.onInput.bind(this);

      this.addEventListener('click', this.onClick);
      this.addEventListener('input', this.onInput);

      this.attachToForm();
      this.updateCounter();

      // Le formulaire est re-rendu au changement de variante
      this.observer = new MutationObserver(SS.debounce(() => this.attachToForm(), 150));
      const host = this.closest('.shopify-section') || document.body;
      this.observer.observe(host, { childList: true, subtree: true });
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('input', this.onInput);
      this.observer?.disconnect();
    }

    /* --- Rattachement au formulaire produit natif ---
       Les champs vivent hors du <form> : on les y relie par l'attribut
       form=, que new FormData(form) prend bien en compte.

       Attention : on passe par getAttribute/setAttribute et jamais par
       form.id. HTMLFormElement expose ses champs nommés en propriétés et
       les fait primer sur celles de l'élément ; comme le formulaire
       produit contient <input name="id">, form.id renvoie cet input, pas
       l'identifiant. On posait donc form="[object HTMLInputElement]" et
       aucune option de la carte cadeau n'était transmise au panier. */
    attachToForm() {
      const form = document.querySelector('form[action*="/cart/add"]');
      if (!form) return;

      let formId = form.getAttribute('id');
      if (!formId) {
        formId = `ss-gc-form-${this.uid}`;
        form.setAttribute('id', formId);
      }
      if (this.formId === formId) return;

      this.formId = formId;
      this.inputs.forEach((input) => input.setAttribute('form', formId));

      if (!form.dataset.ssGcBound) {
        form.dataset.ssGcBound = 'true';
        form.addEventListener('submit', (e) => {
          if (!this.validate()) e.preventDefault();
        });
      }
    }

    /* --- Événements --- */
    onClick(e) {
      const tab = e.target.closest('[data-ss-gc-tab]');
      if (tab) { this.setMode(tab.dataset.ssGcTab); return; }

      if (e.target.closest('[data-ss-gc-preview]')) { this.openPreview(); return; }
      if (e.target.closest('[data-ss-gc-close]')) { this.modal?.close(); return; }

      /* Clic sur le fond. Un <dialog> reçoit lui-même les clics sur son
         backdrop : la cible est alors le dialog, jamais un enfant. */
      if (e.target === this.modal) this.modal.close();
    }

    onInput(e) {
      if (e.target === this.messageInput) this.updateCounter();
      if (e.target === this.emailInput) this.emailInput.removeAttribute('aria-invalid');
    }

    /* --- Mode --- */
    setMode(mode) {
      this.mode = mode;

      this.querySelectorAll('[data-ss-gc-tab]').forEach((tab) => {
        const active = tab.dataset.ssGcTab === mode;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', String(active));
      });

      this.querySelectorAll('[data-ss-gc-panel]').forEach((panel) => {
        panel.hidden = panel.dataset.ssGcPanel !== mode;
      });

      // Une propriété vide est ignorée par Shopify : ça désactive l'envoi auto
      const sending = mode === 'email';
      if (this.sendFlag) this.sendFlag.value = sending ? 'on' : '';
      if (this.emailInput) {
        this.emailInput.required = sending;
        if (!sending) this.emailInput.removeAttribute('aria-invalid');
      }
      if (this.dateInput) this.dateInput.disabled = !sending;
    }

    /* --- Compteur --- */
    updateCounter() {
      if (!this.counter || !this.messageInput) return;
      const left = this.maxChars - this.messageInput.value.length;
      const label = this.counter.dataset.label || 'caractères restants';
      this.counter.textContent = `(${left} ${label})`;
    }

    /* --- Validation --- */
    validate() {
      if (this.mode !== 'email' || !this.emailInput) return true;

      const value = this.emailInput.value.trim();
      const valid = value !== '' && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);

      if (!valid) {
        this.emailInput.setAttribute('aria-invalid', 'true');
        this.emailInput.focus();
        SS.scrollTo(this.emailInput, 120);
      }
      return valid;
    }

    /* --- Aperçu --- */
    openPreview() {
      if (!this.modal) return;

      const get = (sel) => this.querySelector(sel)?.value.trim() || '';
      const set = (sel, text) => {
        const el = this.querySelector(sel);
        if (el) el.textContent = text;
      };

      const priceEl = document.querySelector('[data-cart-total], .price__regular .price-item, .price');
      set('[data-ss-gc-p-amount]', priceEl?.textContent.trim() || '');

      const to = get('[data-ss-gc-to]');
      const from = get('[data-ss-gc-from]');

      set('[data-ss-gc-p-to]', to ? `Pour ${to}` : '');
      set('[data-ss-gc-p-message]', get('[data-ss-gc-message]'));
      set('[data-ss-gc-p-from]', from ? `De la part de ${from}` : '');

      this.modal.showModal();
    }
  });
}